export default __webpack_public_path__ + "static/media/bg-dark-blur-horizontal.018435a2.png";